import { formatNumber } from 'core/service/lib/number-format'

const SummaryRow = ({
  id,
  productCode,
  productName,
  asterisks = '',
  coverageYear,
  paymentPeriod,
  selectedPlan,
  sumAssured,
  showSumAssuredDecimalPlaces,
  premium,
}) => {
  const getSumAssuredDisplayValue = () => {
    if (showSumAssuredDecimalPlaces) {
      return formatNumber(sumAssured, 2)
    } else {
      return formatNumber(sumAssured)
    }
  }
  const displayProductName =
    productCode === '25PL' ? `${productName} ${asterisks}` : `${productName} (${productCode})${asterisks}`
  return (
    <tr id={`summary-row-${id}`}>
      <td>{displayProductName}</td>
      <td>{coverageYear}</td>
      <td>{paymentPeriod}</td>
      <td>{getSumAssuredDisplayValue()}</td>
      <td>{formatNumber(premium, 2)}</td>
    </tr>
  )
}

export default SummaryRow
